import React from 'react'
import styled from 'styled-components'

const LeftQuoteStyle = styled.div`
margin-left: -17em;

@media all and (max-width: 1400px) {
    margin-left: -20em;
  }

  @media all and (max-width: 725px) {
    margin-left: -12em;
  }
`;

export const LeftQuote:React.FC = () => {
    return (
        <LeftQuoteStyle>
            <svg width="27" height="19" viewBox="0 0 27 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.6748 18.8158C5.38001 16.1684 0.768411 10.3612 0.76841 4.981C0.76841 1.6504 2.81801 0.0277995 5.29461 0.0277993C7.94201 0.027799 10.4186 2.2482 10.4186 5.0664C10.4186 7.3722 8.71061 8.9094 6.74641 8.9094C6.57561 8.9094 6.14861 8.9094 6.06321 8.824C7.00261 11.6422 10.1624 14.4604 13.2368 15.9976L10.6748 18.8158ZM24.2534 18.8158C18.9586 16.1684 14.347 10.3612 14.347 4.981C14.347 1.6504 16.3966 0.0277983 18.8732 0.0277981C21.5206 0.0277978 23.9972 2.2482 23.9972 5.0664C23.9972 7.3722 22.2892 8.9094 20.4104 8.9094C20.1542 8.9094 19.8126 8.9094 19.6418 8.824C20.6666 11.6422 23.741 14.4604 26.8154 15.9976L24.2534 18.8158Z" fill="white"/>
</svg>

        </LeftQuoteStyle>
    )
}

export default LeftQuote
